import type {ToastMessage} from "../types/toast-message.type";

/**
 * The icon class each notification level shows (classes of the bundled icon font). Typed by
 * level, so adding a level without an icon is a compile error. The font has no separate warning
 * glyph; warning and error share the triangle and differ by colour (notification.css).
 */
export const NOTIFICATION_ICONS: ReadonlyMap<ToastMessage["level"], string> = new Map<ToastMessage["level"], string>([
    ["success", "icon-circle-check"],
    ["error", "icon-triangle-exclamation"],
    ["warning", "icon-triangle-exclamation"],
    ["info", "icon-circle-info"],
]);

/** The icon class for a notification level. */
export function notificationIcon(level: ToastMessage["level"]): string | undefined {
    return NOTIFICATION_ICONS.get(level);
}
